import axiosInstance from './axiosInstance';

// GET all taskTypes
export const getTaskTypes = async () => {
  try {
    const response = await axiosInstance.get('/task-types');
    return response.data;
  } catch (error) {
    console.error("Error fetching taskTypes:", error.response?.data || error);
    throw error;
  }
};

// GET a single taskType
export const getTaskTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/task-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching taskType:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new taskType
export const createTaskType = async (taskTypeData) => {
  try {
    const response = await axiosInstance.post('/task-types', taskTypeData);
    return response.data;
  } catch (error) {
    console.error("Error creating taskType:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing taskType
export const updateTaskType = async (id, taskTypeData) => {
  try {
    const response = await axiosInstance.put(`/task-types/${id}`, taskTypeData);
    return response.data;
  } catch (error) {
    console.error("Error updating taskType:", error.response?.data || error);
    throw error;
  }
};

// DELETE a taskType
export const deleteTaskType = async (id) => {
  try {
    const response = await axiosInstance.delete(`/task-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting taskType:", error.response?.data || error);
    throw error;
  }
};
